export default __webpack_public_path__ + "static/media/_payment-3d-secure.8ac116a2.svg";